export default "__VITE_ASSET__069a3ba5__"